<template>
  <div>
    <b-row>
      <b-col md="3" style="margin-bottom: 15px">
        <h1>
          <span class="half_background">
            Write your
          </span>
        </h1>
        <h1>
          <span class="half_background">
            <i>letter</i> to God
          </span>
        </h1>
        <feedback-form
            :profile="profile"
            my-app="DearGod"
            />
      </b-col>
      <b-col md="9">
        <h5>
          Welcome to 'Dear God,' where the power of AI meets the timeless wisdom of the King James Bible.
          <span
              class="d-none d-md-inline"
          >
          Immerse yourself in a sacred space where words become a conduit for nurturing support and divine guidance.
          Write from your heart, express your deepest feelings, and let the profound words of the Bible inspire and
          guide you on your spiritual journey. Allow the synergy of technology and scripture to create a unique,
          transformative experience as you open your heart and soul in this sacred dialogue.
          </span>
        </h5>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FeedbackForm from "@/components/common/feedbackSideBar";
export default {
  name: "Display_PaneIntro",
  components: {
    FeedbackForm
  },
  created(){},
  mounted() {},
  props: {
    profile: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  computed: {
    input(){
      return ""
    }
  },
  methods: {
    handleGenerateClick(){
      this.$emit("generate-click", this.input)
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.half_background {
  background: linear-gradient(to top, rgb(203,238,253) 50%, transparent 50%);
}
</style>
